import { motion } from "framer-motion";
import { ArrowDown, Flower } from "lucide-react";

const HERO_IMG =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_retreat-interactive/artifacts/3mjyvp5v_ff574761-fced-4bf2-9b12-b9f9e7e7dffb.webp";

export const Hero = () => (
  <section id="top" className="relative min-h-screen pt-28 pb-16 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 items-center min-h-[calc(100vh-7rem)]">
      <div className="lg:col-span-6 z-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-xs tracking-[0.3em] uppercase text-clay mb-6"
        >
          Sound Healing · Guided Yoga · Renewal
        </motion.p>
        <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-ink">
          {["A retreat to", "cleanse, calm", "and create"].map((line, i) => (
            <motion.span
              key={i}
              className="block"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            >
              {line}
            </motion.span>
          ))}
        </h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="mt-8 text-base sm:text-lg text-muted max-w-md leading-relaxed"
        >
          In the heart of the body lies a quiet you've been missing. Come home to it
          through sound, breath and stillness.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.85 }}
          className="mt-10 flex flex-wrap gap-4"
        >
          <a
            href="#quiz"
            data-testid="hero-start-quiz-btn"
            className="group rounded-full bg-forest text-sand px-8 py-4 text-sm hover:bg-forest-deep transition-colors inline-flex items-center gap-2"
          >
            Find your retreat
            <ArrowDown size={16} className="group-hover:translate-y-1 transition-transform" />
          </a>
          <a
            href="#retreats"
            data-testid="hero-view-retreats-btn"
            className="rounded-full border border-forest/40 text-forest px-8 py-4 text-sm hover:bg-forest hover:text-sand transition-colors"
          >
            View retreats
          </a>
        </motion.div>
      </div>

      <motion.div
        className="lg:col-span-6 relative"
        initial={{ opacity: 0, scale: 1.05 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="overflow-hidden rounded-[2rem] aspect-[4/5] lg:aspect-[3/4]">
          <img src={HERO_IMG} alt="Wellness retreat in nature" className="w-full h-full object-cover" />
        </div>
        <div className="absolute -bottom-6 -left-6 bg-surface rounded-2xl px-6 py-5 hidden sm:block">
          <p className="font-serif text-3xl text-forest leading-none">∞</p>
          <p className="text-xs tracking-wide text-muted mt-1 max-w-[9rem]">A space to return to yourself</p>
        </div>
      </motion.div>
    </div>

    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-muted">
      <span className="text-[0.65rem] tracking-[0.3em] uppercase">Scroll</span>
      <motion.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.8 }}>
        <Flower size={20} className="text-clay" />
      </motion.div>
    </div>
  </section>
);
